module.exports = __webpack_public_path__ + "static/media/2-2.b291487a.svg";